import { Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { FormikButton, FormikGrid, FormikTextField } from '@sierralabs/react-material-ui-formik';
import { useUpdateFormTemplate } from '../FormTemplate.hooks';
export const FormTemplateEditDialog = ({ open, formTemplate, onCancel, onUpdate }) => {
    const { updatedFormTemplate, updateError, isUpdating, updateFormTemplate } = useUpdateFormTemplate(formTemplate.id);
    const [error, setError] = useState();
    const formikRef = useRef(null);
    const onUpdateRef = useRef(onUpdate);
    onUpdateRef.current = onUpdate;
    useEffect(() => {
        var _a;
        if (updatedFormTemplate) {
            (_a = onUpdateRef.current) === null || _a === void 0 ? void 0 : _a.call(onUpdateRef, updatedFormTemplate);
        }
    }, [updatedFormTemplate]);
    useEffect(() => {
        var _a;
        (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.setSubmitting(isUpdating);
    }, [isUpdating]);
    useEffect(() => {
        !open && setError(undefined);
    }, [open]);
    useEffect(() => {
        setError(updateError);
    }, [updateError]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'sm', open: open, onClose: onCancel },
        React.createElement(Formik, { innerRef: formikRef, initialValues: { name: formTemplate.name }, validationSchema: Yup.object({
                name: Yup.string().required('Name is required')
            }), onSubmit: values => updateFormTemplate(values) },
            React.createElement(Form, { autoComplete: 'off' },
                React.createElement(DialogTitle, null, "Edit Form Template"),
                React.createElement(DialogContent, null,
                    React.createElement(FormikGrid, null,
                        React.createElement(FormikTextField, { name: 'name', label: 'Name' })),
                    error && React.createElement(Alert, { severity: 'error' }, error.message)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: onCancel }, "Cancel"),
                    React.createElement(FormikButton, null, "Update"))))));
};
export default FormTemplateEditDialog;
//# sourceMappingURL=FormTemplateEditDialog.js.map